export const keyCodes = Object.freeze({
	'Enter': 13,
	'Esc': 27,
	'Space': 32
})